export const PROXY_SYM = Symbol.for("__rpldy-sstt-proxy__");
export const STATE_SYM = Symbol.for("__rpldy-sstt-state__");